import { getMessages } from '../../../../store/constants';
import {
    AGILE_DEVELOPMENT_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID, CLASSROOM_NEWSLETTER_TEMPLATE_BOARD_ID, CLASSROOM_WORK_TEMPLATE_BOARD_ID,
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
    CUSTOMER_SUPPORT_TEMPLATE_BOARD_ID,
    DESIGN_PROCESS_TEMPLATE_BOARD_ID, EVENT_PLANNING_TEMPLATE_BOARD_ID,
    FINANCIAL_BOARD_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    HIRING_PROCESS_TEMPLATE_BOARD_ID,
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID, LESSON_PLANNING_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    MVP_CREATION_TEMPLATE_BOARD_ID, MY_FIRST_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
    SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID,
    THINGS_CONCEPT_TEMPLATE_BOARD_ID,
    UIUX_DESIGN_WORKFLOW_TEMPLATE_BOARD_ID,
    VIDEO_CREATION_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID
} from '../../../../const';
import { TQualificationTemplatesSet, TQualificationTemplatesSets } from './types';

export const QUALIFICATION_FIRST_QUESTION = 'templates_help_project';
export const QUALIFICATION_HIDE_TIMEOUT = 1000;

export const QUALIFICATION_QUESTIONS_TITLE = getMessages().getText('qualification.questions.title');
export const QUALIFICATION_QUESTIONS_SUBTITLE = getMessages().getText('qualification.questions.subTitle');
export const QUALIFICATION_SKIPPED_TITLE = getMessages().getText('qualification.skipped.title');
export const QUALIFICATION_SKIPPED_SUBTITLE = getMessages().getText('qualification.skipped.subTitle');
export const QUALIFICATION_SKIPPED_NO = getMessages().getText('qualification.skipped.no');
export const QUALIFICATION_COMPLETED_TITLE = getMessages().getText('qualification.completed.title');
export const QUALIFICATION_COMPLETED_SUBTITLE = getMessages().getText('qualification.completed.subTitle');
export const QUALIFICATION_GET_STARTED = getMessages().getText('qualification.getStarted');
export const QUALIFICATION_BACK = getMessages().getText('qualification.back');
export const QUALIFICATION_SKIP = getMessages().getText('qualification.skip');
export const QUALIFICATION_NEXT = getMessages().getText('qualification.next');
export const QUALIFICATION_MORE_DETAILS_PROMPT = getMessages().getText('qualification.questions.moredetails.prompt');

export const SEGMENT_IDENTIFY_PREFIX = 'Q_';

export const QUALIFICATION_QUESTIONS_CALENDAR_URL = 'https://calendly.com/kanbanchi/kanbanchi-introduction?month={date}';
export const QUALIFICATION_QUESTIONS_EDU_CALENDAR_URL = 'https://calendly.com/kanbanchi/kanbanchi-introduction-for-edu?month={date}';

export const NOT_SKIPPABLE_QUESTION_KEYS = [
    'templates_help_func',
];

export const OPERATIONS_OWNER_TEMPLATES_SET = [
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    FINANCIAL_BOARD_TEMPLATE_BOARD_ID,
    SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID,
];

export const OPERATIONS_STARTUP_TEMPLATES_SET = [
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    FINANCIAL_BOARD_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
];

export const OPERATIONS_LEAD_TEMPLATES_SET = [
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const OPERATIONS_MEMBER_TEMPLATES_SET = [
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
];

export const OPERATIONS_EXECUTIVE_TEMPLATES_SET = [
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    FINANCIAL_BOARD_TEMPLATE_BOARD_ID,
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
];

export const OPERATIONS_FREELANCE_TEMPLATES_SET = [
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID,
];

export const OPERATIONS_ADMINISTRATIVE_TEMPLATES_SET = [
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID,
];

export const OPERATIONS_TEMPLATES_SET: TQualificationTemplatesSet = {
    owner: OPERATIONS_OWNER_TEMPLATES_SET,
    startup: OPERATIONS_STARTUP_TEMPLATES_SET,
    lead: OPERATIONS_LEAD_TEMPLATES_SET,
    member: OPERATIONS_MEMBER_TEMPLATES_SET,
    executive: OPERATIONS_EXECUTIVE_TEMPLATES_SET,
    freelance: OPERATIONS_FREELANCE_TEMPLATES_SET,
    admin: OPERATIONS_ADMINISTRATIVE_TEMPLATES_SET,
};

export const MARKETING_OWNER_TEMPLATES_SET = [
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
    DESIGN_PROCESS_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
];

export const MARKETING_STARTUP_TEMPLATES_SET = [
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    MVP_CREATION_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
];

export const MARKETING_LEAD_TEMPLATES_SET = [
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    MVP_CREATION_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const MARKETING_MEMBER_TEMPLATES_SET = [
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    VIDEO_CREATION_TEMPLATE_BOARD_ID,
];

export const MARKETING_EXECUTIVE_TEMPLATES_SET = [
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const MARKETING_FREELANCE_TEMPLATES_SET = [
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
    VIDEO_CREATION_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const MARKETING_ADMINISTRATIVE_TEMPLATES_SET = [
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    THINGS_CONCEPT_TEMPLATE_BOARD_ID,
];

export const MARKETING_TEMPLATES_SET: TQualificationTemplatesSet = {
    owner: MARKETING_OWNER_TEMPLATES_SET,
    startup: MARKETING_STARTUP_TEMPLATES_SET,
    lead: MARKETING_LEAD_TEMPLATES_SET,
    member: MARKETING_MEMBER_TEMPLATES_SET,
    executive: MARKETING_EXECUTIVE_TEMPLATES_SET,
    freelance: MARKETING_FREELANCE_TEMPLATES_SET,
    admin: MARKETING_ADMINISTRATIVE_TEMPLATES_SET,
};

export const SALES_OWNER_TEMPLATES_SET = [
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
];

export const SALES_STARTUP_TEMPLATES_SET = [
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
];

export const SALES_LEAD_TEMPLATES_SET = [
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
];

export const SALES_MEMBER_TEMPLATES_SET = [
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
];

export const SALES_EXECUTIVE_TEMPLATES_SET = [
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
];

export const SALES_FREELANCE_TEMPLATES_SET = [
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    VIDEO_CREATION_TEMPLATE_BOARD_ID,
];

export const SALES_ADMINISTRATIVE_TEMPLATES_SET = [
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
];

export const SALES_TEMPLATES_SET: TQualificationTemplatesSet = {
    owner: SALES_OWNER_TEMPLATES_SET,
    startup: SALES_STARTUP_TEMPLATES_SET,
    lead: SALES_LEAD_TEMPLATES_SET,
    member: SALES_MEMBER_TEMPLATES_SET,
    executive: SALES_EXECUTIVE_TEMPLATES_SET,
    freelance: SALES_FREELANCE_TEMPLATES_SET,
    admin: SALES_ADMINISTRATIVE_TEMPLATES_SET,
};

export const DESIGN_OWNER_TEMPLATES_SET = [
    UIUX_DESIGN_WORKFLOW_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    DESIGN_PROCESS_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
];

export const DESIGN_STARTUP_TEMPLATES_SET = [
    UIUX_DESIGN_WORKFLOW_TEMPLATE_BOARD_ID,
    MVP_CREATION_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    AGILE_DEVELOPMENT_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
];

export const DESIGN_LEAD_TEMPLATES_SET = [
    UIUX_DESIGN_WORKFLOW_TEMPLATE_BOARD_ID,
    DESIGN_PROCESS_TEMPLATE_BOARD_ID,
    AGILE_DEVELOPMENT_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
];

export const DESIGN_MEMBER_TEMPLATES_SET = [
    DESIGN_PROCESS_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    UIUX_DESIGN_WORKFLOW_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID,
];

export const DESIGN_EXECUTIVE_TEMPLATES_SET = [
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    UIUX_DESIGN_WORKFLOW_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
];

export const DESIGN_FREELANCE_TEMPLATES_SET = [
    DESIGN_PROCESS_TEMPLATE_BOARD_ID,
    UIUX_DESIGN_WORKFLOW_TEMPLATE_BOARD_ID,
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    VIDEO_CREATION_TEMPLATE_BOARD_ID,
];

export const DESIGN_ADMINISTRATIVE_TEMPLATES_SET = [
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    DESIGN_PROCESS_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID,
];

export const DESIGN_TEMPLATES_SET: TQualificationTemplatesSet = {
    owner: DESIGN_OWNER_TEMPLATES_SET,
    startup: DESIGN_STARTUP_TEMPLATES_SET,
    lead: DESIGN_LEAD_TEMPLATES_SET,
    member: DESIGN_MEMBER_TEMPLATES_SET,
    executive: DESIGN_EXECUTIVE_TEMPLATES_SET,
    freelance: DESIGN_FREELANCE_TEMPLATES_SET,
    admin: DESIGN_ADMINISTRATIVE_TEMPLATES_SET,
};

export const HR_OWNER_TEMPLATES_SET = [
    HIRING_PROCESS_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    FINANCIAL_BOARD_TEMPLATE_BOARD_ID,
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
];

export const HR_STARTUP_TEMPLATES_SET = [
    HIRING_PROCESS_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
];

export const HR_LEAD_TEMPLATES_SET = [
    HIRING_PROCESS_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const HR_MEMBER_TEMPLATES_SET = [
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    HIRING_PROCESS_TEMPLATE_BOARD_ID,
    SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
];

export const HR_EXECUTIVE_TEMPLATES_SET = [
    HIRING_PROCESS_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const HR_FREELANCE_TEMPLATES_SET = [
    HIRING_PROCESS_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const HR_ADMINISTRATIVE_TEMPLATES_SET = [
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    HIRING_PROCESS_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const HR_TEMPLATES_SET: TQualificationTemplatesSet = {
    owner: HR_OWNER_TEMPLATES_SET,
    startup: HR_STARTUP_TEMPLATES_SET,
    lead: HR_LEAD_TEMPLATES_SET,
    member: HR_MEMBER_TEMPLATES_SET,
    executive: HR_EXECUTIVE_TEMPLATES_SET,
    freelance: HR_FREELANCE_TEMPLATES_SET,
    admin: HR_ADMINISTRATIVE_TEMPLATES_SET,
};

export const SUPPORT_OWNER_TEMPLATES_SET = [
    CUSTOMER_SUPPORT_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    FINANCIAL_BOARD_TEMPLATE_BOARD_ID,
    SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID,
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
];

export const SUPPORT_STARTUP_TEMPLATES_SET = [
    CUSTOMER_SUPPORT_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
];

export const SUPPORT_LEAD_TEMPLATES_SET = [
    CUSTOMER_SUPPORT_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const SUPPORT_MEMBER_TEMPLATES_SET = [
    CUSTOMER_SUPPORT_TEMPLATE_BOARD_ID,
    SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const SUPPORT_EXECUTIVE_TEMPLATES_SET = [
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    CUSTOMER_SUPPORT_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
];

export const SUPPORT_FREELANCE_TEMPLATES_SET = [
    CUSTOMER_SUPPORT_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
    SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
];

export const SUPPORT_ADMINISTRATIVE_TEMPLATES_SET = [
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    CUSTOMER_SUPPORT_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const SUPPORT_TEMPLATES_SET: TQualificationTemplatesSet = {
    owner: SUPPORT_OWNER_TEMPLATES_SET,
    startup: SUPPORT_STARTUP_TEMPLATES_SET,
    lead: SUPPORT_LEAD_TEMPLATES_SET,
    member: SUPPORT_MEMBER_TEMPLATES_SET,
    executive: SUPPORT_EXECUTIVE_TEMPLATES_SET,
    freelance: SUPPORT_FREELANCE_TEMPLATES_SET,
    admin: SUPPORT_ADMINISTRATIVE_TEMPLATES_SET,
};

export const CONTENT_OWNER_TEMPLATES_SET = [
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
    VIDEO_CREATION_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
];

export const CONTENT_STARTUP_TEMPLATES_SET = [
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
    VIDEO_CREATION_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
];

export const CONTENT_LEAD_TEMPLATES_SET = [
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    VIDEO_CREATION_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID,
];

export const CONTENT_MEMBER_TEMPLATES_SET = [
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
    VIDEO_CREATION_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const CONTENT_EXECUTIVE_TEMPLATES_SET = [
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
];

export const CONTENT_FREELANCE_TEMPLATES_SET = [
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
    VIDEO_CREATION_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
];

export const CONTENT_ADMINISTRATIVE_TEMPLATES_SET = [
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID,
];

export const CONTENT_TEMPLATES_SET: TQualificationTemplatesSet = {
    owner: CONTENT_OWNER_TEMPLATES_SET,
    startup: CONTENT_STARTUP_TEMPLATES_SET,
    lead: CONTENT_LEAD_TEMPLATES_SET,
    member: CONTENT_MEMBER_TEMPLATES_SET,
    executive: CONTENT_EXECUTIVE_TEMPLATES_SET,
    freelance: CONTENT_FREELANCE_TEMPLATES_SET,
    admin: CONTENT_ADMINISTRATIVE_TEMPLATES_SET,
};

export const PRODUCT_OWNER_TEMPLATES_SET = [
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    MVP_CREATION_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
];

export const PRODUCT_STARTUP_TEMPLATES_SET = [
    MVP_CREATION_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    AGILE_DEVELOPMENT_TEMPLATE_BOARD_ID,
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
];

export const PRODUCT_LEAD_TEMPLATES_SET = [
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
];

export const PRODUCT_MEMBER_TEMPLATES_SET = [
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
];

export const PRODUCT_EXECUTIVE_TEMPLATES_SET = [
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    MVP_CREATION_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
];

export const PRODUCT_FREELANCE_TEMPLATES_SET = [
    MVP_CREATION_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    UIUX_DESIGN_WORKFLOW_TEMPLATE_BOARD_ID,
];

export const PRODUCT_ADMINISTRATIVE_TEMPLATES_SET = [
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
];

export const PRODUCT_TEMPLATES_SET: TQualificationTemplatesSet = {
    owner: PRODUCT_OWNER_TEMPLATES_SET,
    startup: PRODUCT_STARTUP_TEMPLATES_SET,
    lead: PRODUCT_LEAD_TEMPLATES_SET,
    member: PRODUCT_MEMBER_TEMPLATES_SET,
    executive: PRODUCT_EXECUTIVE_TEMPLATES_SET,
    freelance: PRODUCT_FREELANCE_TEMPLATES_SET,
    admin: PRODUCT_ADMINISTRATIVE_TEMPLATES_SET,
};

export const IT_OWNER_TEMPLATES_SET = [
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
];

export const IT_STARTUP_TEMPLATES_SET = [
    MVP_CREATION_TEMPLATE_BOARD_ID,
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
];

export const IT_LEAD_TEMPLATES_SET = [
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const IT_MEMBER_TEMPLATES_SET = [
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
];

export const IT_EXECUTIVE_TEMPLATES_SET = [
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
];

export const IT_FREELANCE_TEMPLATES_SET = [
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    UIUX_DESIGN_WORKFLOW_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
];

export const IT_ADMINISTRATIVE_TEMPLATES_SET = [
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const IT_TEMPLATES_SET: TQualificationTemplatesSet = {
    owner: IT_OWNER_TEMPLATES_SET,
    startup: IT_STARTUP_TEMPLATES_SET,
    lead: IT_LEAD_TEMPLATES_SET,
    member: IT_MEMBER_TEMPLATES_SET,
    executive: IT_EXECUTIVE_TEMPLATES_SET,
    freelance: IT_FREELANCE_TEMPLATES_SET,
    admin: IT_ADMINISTRATIVE_TEMPLATES_SET,
};

export const BUSINESS_OWNER_TEMPLATES_SET = [
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
];

export const BUSINESS_STARTUP_TEMPLATES_SET = [
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    MVP_CREATION_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
];

export const BUSINESS_LEAD_TEMPLATES_SET = [
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
];

export const BUSINESS_MEMBER_TEMPLATES_SET = [
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    THINGS_CONCEPT_TEMPLATE_BOARD_ID,
];

export const BUSINESS_EXECUTIVE_TEMPLATES_SET = [
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
];

export const BUSINESS_FREELANCE_TEMPLATES_SET = [
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    AGILE_DEVELOPMENT_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const BUSINESS_ADMINISTRATIVE_TEMPLATES_SET = [
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    EVENT_PLANNING_TEMPLATE_BOARD_ID,
];

export const BUSINESS_TEMPLATES_SET: TQualificationTemplatesSet = {
    owner: BUSINESS_OWNER_TEMPLATES_SET,
    startup: BUSINESS_STARTUP_TEMPLATES_SET,
    lead: BUSINESS_LEAD_TEMPLATES_SET,
    member: BUSINESS_MEMBER_TEMPLATES_SET,
    executive: BUSINESS_EXECUTIVE_TEMPLATES_SET,
    freelance: BUSINESS_FREELANCE_TEMPLATES_SET,
    admin: BUSINESS_ADMINISTRATIVE_TEMPLATES_SET,
};

export const RND_OWNER_TEMPLATES_SET = [
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
];

export const RND_STARTUP_TEMPLATES_SET = [
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    MVP_CREATION_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
];

export const RND_LEAD_TEMPLATES_SET = [
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
];

export const RND_MEMBER_TEMPLATES_SET = [
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    THINGS_CONCEPT_TEMPLATE_BOARD_ID,
];

export const RND_EXECUTIVE_TEMPLATES_SET = [
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
];

export const RND_FREELANCE_TEMPLATES_SET = [
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    AGILE_DEVELOPMENT_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const RND_ADMINISTRATIVE_TEMPLATES_SET = [
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    EVENT_PLANNING_TEMPLATE_BOARD_ID,
];

export const RND_TEMPLATES_SET: TQualificationTemplatesSet = {
    owner: RND_OWNER_TEMPLATES_SET,
    startup: RND_STARTUP_TEMPLATES_SET,
    lead: RND_LEAD_TEMPLATES_SET,
    member: RND_MEMBER_TEMPLATES_SET,
    executive: RND_EXECUTIVE_TEMPLATES_SET,
    freelance: RND_FREELANCE_TEMPLATES_SET,
    admin: RND_ADMINISTRATIVE_TEMPLATES_SET,
};

export const FINANCE_OWNER_TEMPLATES_SET = [
    FINANCIAL_BOARD_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
];

export const FINANCE_STARTUP_TEMPLATES_SET = [
    FINANCIAL_BOARD_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
];

export const FINANCE_LEAD_TEMPLATES_SET = [
    FINANCIAL_BOARD_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const FINANCE_MEMBER_TEMPLATES_SET = [
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    FINANCIAL_BOARD_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    THINGS_CONCEPT_TEMPLATE_BOARD_ID,
];

export const FINANCE_EXECUTIVE_TEMPLATES_SET = [
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    FINANCIAL_BOARD_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
];

export const FINANCE_FREELANCE_TEMPLATES_SET = [
    FINANCIAL_BOARD_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const FINANCE_ADMINISTRATIVE_TEMPLATES_SET = [
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    FINANCIAL_BOARD_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
];

export const FINANCE_TEMPLATES_SET: TQualificationTemplatesSet = {
    owner: FINANCE_OWNER_TEMPLATES_SET,
    startup: FINANCE_STARTUP_TEMPLATES_SET,
    lead: FINANCE_LEAD_TEMPLATES_SET,
    member: FINANCE_MEMBER_TEMPLATES_SET,
    executive: FINANCE_EXECUTIVE_TEMPLATES_SET,
    freelance: FINANCE_FREELANCE_TEMPLATES_SET,
    admin: FINANCE_ADMINISTRATIVE_TEMPLATES_SET,
};

export const EVENT_OWNER_TEMPLATES_SET = [
    EVENT_PLANNING_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
];

export const EVENT_STARTUP_TEMPLATES_SET = [
    EVENT_PLANNING_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
];

export const EVENT_LEAD_TEMPLATES_SET = [
    EVENT_PLANNING_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
];

export const EVENT_MEMBER_TEMPLATES_SET = [
    EVENT_PLANNING_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    THINGS_CONCEPT_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const EVENT_EXECUTIVE_TEMPLATES_SET = [
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    EVENT_PLANNING_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
];

export const EVENT_FREELANCE_TEMPLATES_SET = [
    EVENT_PLANNING_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    THINGS_CONCEPT_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const EVENT_ADMINISTRATIVE_TEMPLATES_SET = [
    EVENT_PLANNING_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    THINGS_CONCEPT_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
];

export const EVENT_TEMPLATES_SET: TQualificationTemplatesSet = {
    owner: EVENT_OWNER_TEMPLATES_SET,
    startup: EVENT_STARTUP_TEMPLATES_SET,
    lead: EVENT_LEAD_TEMPLATES_SET,
    member: EVENT_MEMBER_TEMPLATES_SET,
    executive: EVENT_EXECUTIVE_TEMPLATES_SET,
    freelance: EVENT_FREELANCE_TEMPLATES_SET,
    admin: EVENT_ADMINISTRATIVE_TEMPLATES_SET,
};

export const EDU_OWNER_TEMPLATES_SET = [
    CLASSROOM_WORK_TEMPLATE_BOARD_ID,
    LESSON_PLANNING_TEMPLATE_BOARD_ID,
    CLASSROOM_NEWSLETTER_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    EVENT_PLANNING_TEMPLATE_BOARD_ID
];

export const EDU_STARTUP_TEMPLATES_SET = [
    LESSON_PLANNING_TEMPLATE_BOARD_ID,
    CLASSROOM_NEWSLETTER_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
    EVENT_PLANNING_TEMPLATE_BOARD_ID,
    CLASSROOM_WORK_TEMPLATE_BOARD_ID,
];

export const EDU_LEAD_TEMPLATES_SET = [
    LESSON_PLANNING_TEMPLATE_BOARD_ID,
    CLASSROOM_NEWSLETTER_TEMPLATE_BOARD_ID,
    CLASSROOM_WORK_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
];

export const EDU_MEMBER_TEMPLATES_SET = [
    CLASSROOM_WORK_TEMPLATE_BOARD_ID,
    LESSON_PLANNING_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    CLASSROOM_NEWSLETTER_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
];

export const EDU_EXECUTIVE_TEMPLATES_SET = [
    CLASSROOM_WORK_TEMPLATE_BOARD_ID,
    LESSON_PLANNING_TEMPLATE_BOARD_ID,
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    EVENT_PLANNING_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
];

export const EDU_FREELANCE_TEMPLATES_SET = [
    CLASSROOM_WORK_TEMPLATE_BOARD_ID,
    LESSON_PLANNING_TEMPLATE_BOARD_ID,
    CLASSROOM_NEWSLETTER_TEMPLATE_BOARD_ID,
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
    VIDEO_CREATION_TEMPLATE_BOARD_ID,
];

export const EDU_ADMINISTRATIVE_TEMPLATES_SET = [
    LESSON_PLANNING_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID,
    CLASSROOM_WORK_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    CLASSROOM_NEWSLETTER_TEMPLATE_BOARD_ID,
];

export const EDU_TEMPLATES_SET: TQualificationTemplatesSet = {
    owner: EDU_OWNER_TEMPLATES_SET,
    startup: EDU_STARTUP_TEMPLATES_SET,
    lead: EDU_LEAD_TEMPLATES_SET,
    member: EDU_MEMBER_TEMPLATES_SET,
    executive: EDU_EXECUTIVE_TEMPLATES_SET,
    freelance: EDU_FREELANCE_TEMPLATES_SET,
    admin: EDU_ADMINISTRATIVE_TEMPLATES_SET,
};

export const OTHER_OWNER_TEMPLATES_SET = [
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    FINANCIAL_BOARD_TEMPLATE_BOARD_ID,
    SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID
];

export const OTHER_STARTUP_TEMPLATES_SET = [
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    FINANCIAL_BOARD_TEMPLATE_BOARD_ID,
    SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
];

export const OTHER_LEAD_TEMPLATES_SET = [
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
];

export const OTHER_MEMBER_TEMPLATES_SET = [
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
];

export const OTHER_EXECUTIVE_TEMPLATES_SET = [
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
    FINANCIAL_BOARD_TEMPLATE_BOARD_ID,
];

export const OTHER_FREELANCE_TEMPLATES_SET = [
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
];

export const OTHER_ADMINISTRATIVE_TEMPLATES_SET = [
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
    FINANCIAL_BOARD_TEMPLATE_BOARD_ID,
];

export const OTHER_TEMPLATES_SET: TQualificationTemplatesSet = {
    owner: OTHER_OWNER_TEMPLATES_SET,
    startup: OTHER_STARTUP_TEMPLATES_SET,
    lead: OTHER_LEAD_TEMPLATES_SET,
    member: OTHER_MEMBER_TEMPLATES_SET,
    executive: OTHER_EXECUTIVE_TEMPLATES_SET,
    freelance: OTHER_FREELANCE_TEMPLATES_SET,
    admin: OTHER_ADMINISTRATIVE_TEMPLATES_SET,
};

export const TEMPLATES_SETS: TQualificationTemplatesSets = {
    operations: OPERATIONS_TEMPLATES_SET,
    marketing: MARKETING_TEMPLATES_SET,
    sales: SALES_TEMPLATES_SET,
    design: DESIGN_TEMPLATES_SET,
    hr: HR_TEMPLATES_SET,
    support: SUPPORT_TEMPLATES_SET,
    content: CONTENT_TEMPLATES_SET,
    product: PRODUCT_TEMPLATES_SET,
    it: IT_TEMPLATES_SET,
    business: BUSINESS_TEMPLATES_SET,
    rnd: RND_TEMPLATES_SET,
    finance: FINANCE_TEMPLATES_SET,
    event: EVENT_TEMPLATES_SET,
    edu_prof: EDU_TEMPLATES_SET,
    other: OTHER_TEMPLATES_SET,
    student: MY_FIRST_TEMPLATE_BOARD_ID,
    personal: MY_FIRST_TEMPLATE_BOARD_ID,
    teacher: LESSON_PLANNING_TEMPLATE_BOARD_ID,
};
